<div class="poi-card">
  @if (description()) {
    <div class="poi-card__title">
      {{ description() }}
    </div>
  }

  @if (purpose()) {
    <div class="poi-card__purpose">
      {{ purpose() }}
    </div>
  }

  @if (description() || purpose()) {
    <div class="poi-card__divider"></div>
  }

  <div class="poi-card__content">
    @if (iconSvg) {
      <div class="poi-card__icon" [innerHTML]="iconSvg"></div>
    } @else {
      <img class="poi-card__icon" src="./assets/map-marker-default.svg" />
    }
    <div class="poi-card__details">
      <div class="poi-card__type">
        {{ poiTypeKey() || 'PoiType.Unknown' | translate }}
      </div>

      <div class="poi-card__severity">
        {{ severityKey() || 'PoiSeverity.Unknown' | translate }}
      </div>
    </div>
  </div>
</div>
